import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import '../product/ViewProduct.css';
import NaveBar from '../NaveBar/NaveBar';
import Footer from '../../footer/footer/footer';

function ViewProduct() {
  const { id } = useParams(); 
  const [product, setProduct] = useState(null);

  useEffect(() => {
    fetch(`https://fakestoreapi.com/products/${id}`)
      .then(res => res.json())
      .then(data => setProduct(data))
      .catch(err => console.error("Error fetching product:", err));
  }, [id]);

  if (!product) return <p>Loading...</p>;
  return (
    <div className='all-cards'>
        < NaveBar />
    <div className="Viewproduct">
      <Card>
        <div className='product-img'>
        <Card.Img  src={product.image} style={{ height: '200px', objectFit: 'contain' }} />
        </div>
        <div className='product-body'>
        <Card.Body>
          <Card.Title style={{fontSize: '30px'}}>{product.title}</Card.Title>
          <Card.Text><strong>Category:</strong> {product.category}</Card.Text>
          <Card.Text style={{color: 'green', fontSize: '20px'}}><strong>Price:</strong> ₹{product.price}</Card.Text>
          <Card.Text><strong>Description:</strong> {product.description}</Card.Text>
          <Link to="/home">
            <Button variant="secondary">Go Back</Button>
          </Link>
        </Card.Body>
        </div>
      </Card>
    </div>
         <Footer />
    </div>
  );
}

export default ViewProduct;
